import { borderRadius, width } from '@mui/system';
import { colors } from 'Constants/Colors';

const containerPermissions = {
  width: '100%',
  background: '#f6f7fc',
  height: 'auto',
  minHeight: '100vh',
};

const searchContainer = {
  display: 'flex',
  alignItems: 'center',
  width: '93%',
  margin: 'auto',
  marginBottom: '3rem',
  justifyContent: 'space-between',
};

const tableContainer = {
  width: '93%',
  alignItems: 'center',
  margin: 'auto',
};

const findContainer = {
  width: '50%',
  justifyContent: 'flex-end',
};

export default {
  containerPermissions,
  searchContainer,
  findContainer,
  tableContainer,
};
